import { queryOptions } from '@tanstack/react-query'
import { api, unwrap } from '~/lib/api'

// The overview reads every module, so lib/stream.ts invalidates ['club'] on every change event.
export const clubKeys = {
  all: ['club'] as const,
  overview: (orgId: string) => ['club', orgId] as const,
}

export const clubQuery = (orgId: string) =>
  queryOptions({
    queryKey: clubKeys.overview(orgId),
    queryFn: () => unwrap(api.club.$get()),
  })

export type Club = Awaited<ReturnType<NonNullable<ReturnType<typeof clubQuery>['queryFn']>>>
export type ClubTeam = Club['teams'][number]
